(function () {
  function initCompareModels(root) {
    if (root.dataset.cmScrollbarInit === '1') return;
    root.dataset.cmScrollbarInit = '1';

    var scrollEl = root.querySelector('[data-compare-models-scroll-el]');
    var bar = root.querySelector('[data-compare-models-scrollbar]');
    if (!scrollEl || !bar) return;

    var track = bar.querySelector('.cm-scrollbar-ui__track');
    var thumb = bar.querySelector('.cm-scrollbar-ui__thumb');
    if (!track || !thumb) return;

    var state = {
      maxScroll: 0,
      maxThumbLeft: 0,
      thumbW: 0,
      trackW: 0,
    };

    var thumbDrag = null;
    var trackDragPointerId = null;

    function hasOverflow() {
      return scrollEl.scrollWidth > scrollEl.clientWidth + 1;
    }

    function readSizes() {
      var sw = scrollEl.scrollWidth;
      var cw = scrollEl.clientWidth;
      var overflow = sw > cw + 1;

      bar.hidden = !overflow;
      root.classList.toggle('cm-has-overflow', overflow);

      if (!overflow) {
        state.maxScroll = 0;
        state.maxThumbLeft = 0;
        state.thumbW = 0;
        state.trackW = 0;
        return false;
      }

      state.trackW = track.clientWidth || track.getBoundingClientRect().width;
      if (state.trackW <= 0) return true;

      state.maxScroll = Math.max(0, sw - cw);
      var ratio = Math.min(1, cw / sw);
      state.thumbW = Math.max(28, Math.min(state.trackW, Math.round(state.trackW * ratio)));
      state.maxThumbLeft = Math.max(0, state.trackW - state.thumbW);
      return true;
    }

    function applyThumbTransform() {
      if (!state.maxScroll || state.maxThumbLeft <= 0) {
        thumb.style.transform = 'translate3d(0,0,0)';
        return;
      }
      var left = (scrollEl.scrollLeft / state.maxScroll) * state.maxThumbLeft;
      thumb.style.transform = 'translate3d(' + left + 'px,0,0)';
    }

    function update() {
      if (!readSizes()) return;
      thumb.style.width = state.thumbW + 'px';
      applyThumbTransform();
    }

    function setScrollFromThumbLeft(thumbLeft) {
      if (state.maxScroll <= 0) return;
      var tl = Math.max(0, Math.min(state.maxThumbLeft, thumbLeft));
      scrollEl.scrollLeft =
        state.maxThumbLeft <= 0 ? 0 : (tl / state.maxThumbLeft) * state.maxScroll;
      applyThumbTransform();
    }

    function clientXToThumbLeft(clientX) {
      var tr = track.getBoundingClientRect();
      return clientX - tr.left;
    }

    /* ---- Thumb drag (Swiper-like) ---- */
    thumb.addEventListener('pointerdown', function (e) {
      if (bar.hidden || !hasOverflow()) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      e.preventDefault();
      e.stopPropagation();
      try {
        thumb.setPointerCapture(e.pointerId);
      } catch (_) {}
      var thRect = thumb.getBoundingClientRect();
      thumbDrag = {
        pointerId: e.pointerId,
        offsetX: e.clientX - thRect.left,
      };
      document.body.style.userSelect = 'none';
      document.body.style.cursor = 'grabbing';
    });

    thumb.addEventListener('pointermove', function (e) {
      if (!thumbDrag || thumbDrag.pointerId !== e.pointerId) return;
      e.preventDefault();
      readSizes();
      var xInTrack = clientXToThumbLeft(e.clientX);
      var thumbLeft = xInTrack - thumbDrag.offsetX;
      setScrollFromThumbLeft(thumbLeft);
    });

    function endThumbDrag(e) {
      if (!thumbDrag || e.pointerId !== thumbDrag.pointerId) return;
      try {
        thumb.releasePointerCapture(e.pointerId);
      } catch (_) {}
      thumbDrag = null;
      document.body.style.userSelect = '';
      document.body.style.cursor = '';
    }

    thumb.addEventListener('pointerup', endThumbDrag);
    thumb.addEventListener('pointercancel', endThumbDrag);

    /* ---- Track: click / drag to scrub (like Swiper scrollbar) ---- */
    function moveTrackToClientX(clientX) {
      readSizes();
      var x = clientXToThumbLeft(clientX);
      var thumbLeft = x - state.thumbW / 2;
      setScrollFromThumbLeft(thumbLeft);
    }

    track.addEventListener('pointerdown', function (e) {
      if (bar.hidden || !hasOverflow()) return;
      if (e.target === thumb) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      e.preventDefault();
      try {
        track.setPointerCapture(e.pointerId);
      } catch (_) {}
      trackDragPointerId = e.pointerId;
      document.body.style.userSelect = 'none';
      moveTrackToClientX(e.clientX);
    });

    track.addEventListener('pointermove', function (e) {
      if (trackDragPointerId !== e.pointerId) return;
      e.preventDefault();
      moveTrackToClientX(e.clientX);
    });

    function endTrackDrag(e) {
      if (trackDragPointerId !== e.pointerId) return;
      try {
        track.releasePointerCapture(e.pointerId);
      } catch (_) {}
      trackDragPointerId = null;
      document.body.style.userSelect = '';
    }

    track.addEventListener('pointerup', endTrackDrag);
    track.addEventListener('pointercancel', endTrackDrag);

    scrollEl.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function () {
        update();
      });
      ro.observe(scrollEl);
      ro.observe(root);
      var table = scrollEl.querySelector('.cm-table');
      if (table) ro.observe(table);
    }

    scrollEl.querySelectorAll('img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', update, { passive: true });
      img.addEventListener('error', update, { passive: true });
    });

    window.addEventListener('load', update);
    update();
    requestAnimationFrame(update);
    setTimeout(update, 100);
    setTimeout(update, 400);

    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.contains && e.target.contains(root)) {
        requestAnimationFrame(update);
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-compare-models]').forEach(initCompareModels);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
